require("./bootstrap");

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";

import PrimeVue from "primevue/config";
import "primevue/resources/primevue.min.css";
// import "primevue/resources/themes/tailwind-light/theme.css";
import "primeicons/primeicons.css";
import locale from "./config/locale";

import VueAnimXYZ from "@animxyz/vue3";
import "@animxyz/core";

import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Card from "primevue/card";
import Toolbar from "primevue/toolbar";
import InputText from "primevue/inputtext";
import TextArea from "primevue/textarea";
import Password from "primevue/password";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Sidebar from "primevue/sidebar";
import Divider from "primevue/divider";
import InputSwitch from "primevue/inputswitch";
import Checkbox from "primevue/checkbox";
import MultiSelect from "primevue/multiselect";
import Chip from "primevue/chip";
import Tooltip from "primevue/tooltip";
import Tag from "primevue/tag";
import Menu from "primevue/menu";
import ProgressSpinner from "primevue/progressspinner";
import Calendar from "primevue/calendar";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Panel from "primevue/panel";

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText || "Shipro";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return (
            createApp({ render: () => h(app, props) })
                .use(ToastService)

                .use(plugin)
                .use(PrimeVue, { locale })
                .use(VueAnimXYZ)

                // VuePrime components
                .component("Toast", Toast)
                .component("DataTable", DataTable)
                .component("Column", Column)
                .component("Card", Card)
                .component("Toolbar", Toolbar)
                .component("InputText", InputText)
                .component("TextArea", TextArea)
                .component("Password", Password)
                .component("Button", Button)
                .component("Dropdown", Dropdown)
                .component("Dialog", Dialog)
                .component("Sidebar", Sidebar)
                .component("Divider", Divider)
                .component("InputSwitch", InputSwitch)
                .component("Checkbox", Checkbox)
                .component("MultiSelect", MultiSelect)
                .component("Chip", Chip)
                .component("Tag", Tag)
                .component("Menu", Menu)
                .component("ProgressSpinner", ProgressSpinner)
                .component("Calendar", Calendar)
                .component("Accordion", Accordion)
                .component("AccordionTab", AccordionTab)
                .component("Panel", Panel)

                .directive("Tooltip", Tooltip)

                .mixin({ methods: { route } })
                .mount(el)
        );
    },
});

InertiaProgress.init({ color: "#2E5F98" });
